import { FC } from 'react';

type Props = {
    children?: string;
};

const InputError: FC<Props> = ({ children = 'Please complete this required field.' }) => {
    return <div className={'graphik tw-pt-1 tw-text-xs tw-text-red-500'}>{children}</div>;
};

export default InputError;
